export default {
  title: {
    id: 'bo_sellers-orders-drawers-cancel_pickup_modal-title',
    defaultMessage: 'Cancel pickup',
  },
  prompt: {
    id: 'bo_sellers-orders-drawers-cancel_pickup_modal-are_you_sure',
    defaultMessage: 'Are you sure you want to cancel this pickup?',
  },
  confirm: {
    id: 'bo_sellers-orders-drawers-cancel_pickup_modal-confirm_cancel',
    defaultMessage: 'Yes, cancel pickup',
  },
  cancel: {
    id: 'bo_sellers-orders-drawers-cancel_pickup_modal-cancel',
    defaultMessage: 'No, keep pickup date',
  },
  success: {
    id: 'bo_sellers-orders-drawers-cancel_pickup_modal-cancelled',
    defaultMessage: 'The pickup has been cancelled',
  },
} as const
